import { navigate } from 'gatsby-plugin-intl';
import { useCallback } from 'react';

export const useNavigation = (to: string) => {
  return useCallback(() => navigate(to), [to]);
};
